import toTitleCase from './toTitleCase'

/**
 * Display label for a claims nature. The BE key "Attritional LR" should
 * render as "Attritional" in table headers (and similar UI).
 */
export default function formatClaimsNatureLabel(raw: string): string {
  const stripped = raw.replace(/\s+lr$/i, '').trim()
  return toTitleCase(stripped || raw)
}
